import { CLIENT_ID, CLIENT_SECRET, IDENTITY_URL } from '../../utils/constants';

import request from '../request';

export default {
  getServerToken: async (email, password) => {
    const body = new URLSearchParams();
    body.append('username', email);
    body.append('password', password);
    body.append('client_id', CLIENT_ID);
    body.append('client_secret', CLIENT_SECRET);
    body.append('grant_type', 'password');
    body.append('scope', 'svilaApi openid offline_access');

    return request(`${IDENTITY_URL}/connect/token`, 'POST', body, {
      'Content-Type': 'application/x-www-form-urlencoded',
    });
  },

  getUserInfo: async () => {
    return request(`${IDENTITY_URL}/connect/userinfo`, 'get');
  },

  get: async (userId) => request(`${IDENTITY_URL}/api/users/${userId}`, 'get'),
  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${IDENTITY_URL}/api/users`, 'post', body);
  },
  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${IDENTITY_URL}/api/users/${id}`, 'PUT', body);
  },
  updateWithoutRoles: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${IDENTITY_URL}/api/users/simple/${id}`, 'PUT', body);
  },
};
